<template>
  <div id="page-header" class="row bg-dark text-white align-items-center py-2">
    <div class="col">
      <button class="btn btn-primary" @click.prevent="back"><fa-icon icon="chevron-left" /> Back</button>
    </div>
    <div class="col-6 px-0 text-center vertical-align-center">
      <span class="page-title"><fa-icon v-if="pageIcon" :icon="pageIcon" /> {{ pageTitle }}</span>
    </div>
    <div class="col text-right">
      <mz-controls></mz-controls>
    </div>
  </div>  
</template>

<script>
import Controls from '@/components/controls/Controls'
import { mapGetters } from 'vuex'

export default {
  name: 'pageHeader',
  computed: {
    ...mapGetters(['pageTitle', 'pageIcon'])
  },
  methods: {
    back (e) {
      e.target.blur()

      this.$router.go(-1)
    }
  },
  components: {
    mzControls: Controls
  }
}
</script>

<style lang="scss">
.page-title {
  font-weight: 300;
  font-size: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/PageHeader.vue